import { Status } from 'components/status-icon';
import { RbacListResponse, RbacResponse } from 'sync/response.types';

export enum ExecutionStatus {
  Pending = 'pending',
  Cancelled = 'cancelled',
  Invalidated = 'invalidated',
  Running = 'queued',
  FailedToQueue = 'failedToQueue',
  Completed = 'completed',
}

export const EXECUTION_STATUS_LABELS: Record<ExecutionStatus, string> = {
  [ExecutionStatus.Running]: 'Running',
  [ExecutionStatus.Pending]: 'Pending',
  [ExecutionStatus.Completed]: 'Completed',
  [ExecutionStatus.Cancelled]: 'Cancelled',
  [ExecutionStatus.Invalidated]: 'Invalidated',
  [ExecutionStatus.FailedToQueue]: 'Incomplete',
} as const;

export const EXECUTION_STATUS_STATES: Record<ExecutionStatus, Status> = {
  [ExecutionStatus.Running]: 'active',
  [ExecutionStatus.Pending]: 'default',
  [ExecutionStatus.Completed]: 'success',
  [ExecutionStatus.Cancelled]: 'error',
  [ExecutionStatus.Invalidated]: 'default',
  [ExecutionStatus.FailedToQueue]: 'error',
} as const;

export type MaintenanceExecution = {
  status: ExecutionStatus;
  queuedAt?: string;
};

export type MaintenanceImages = {
  currentImages: string[];
  newImage: string;
  provider?: string;
};

export type MaintenanceConfig = {
  type: string;
  images?: MaintenanceImages;
  optional: boolean;
  visibility: string;
  title: string;
  priority: string;
  description: string;
  releaseNotes?: string[];
  link?: string;
};

export type MaintenanceWindow = {
  startDate: string;
  endDate: string;
};

export type MaintenanceJob = {
  id: string;
  schedulingRequestId: string;
  tenantId: string;
  projectId: string;
  clusterId: string;
  config: MaintenanceConfig;
  schedule: {
    queueAt: string;
  };
  createdByUserName: string;
  isSelfServiceUpgrade?: boolean;
  execution: MaintenanceExecution;
  createdByUserID: string;
  upsertedByUserID: string;
  createdAt: string;
  upsertedAt: string;
  modifiedByUserID: string;
  modifiedAt: string;
  version: number;
  window: MaintenanceWindow;
  syncGatewayId?: string;
  serviceType: string;
};

export type MaintenanceJobResponse = RbacResponse<MaintenanceJob>;

export type MaintenanceJobListResponse = RbacListResponse<MaintenanceJobResponse>;

export type MaintenanceJobContext = {
  organizationId: string;
  projectId: string;
  databaseId: string;
  maintenanceId?: string;
};

export type AppServiceMaintenanceJobContext = {
  organizationId: string;
  projectId: string;
  databaseId: string;
  appServiceId: string;
  maintenanceId?: string;
};

export type MaintenanceJobEditPayload = {
  queueAt: string;
};
